// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidden {
  display: none;
}

.tagPostCard {
  height: auto;
  background: var(--planeed-color-white);
  padding-bottom: 1px;
  padding-top: 1px;
  padding-left: 14px;
  margin-bottom: -10px;
}
.tagPostCard ul {
  width: 89%;
  background: var(--planeed-color-white);
  list-style-type: none;
  padding: 0;
  left: 16px;
  z-index: 999;
  border: 1px var(--ion-color-medium-tint) solid;
  border-radius: 5px;
  max-height: 90px;
  overflow: auto;
}
.tagPostCard ul li {
  padding: 2px 15px;
  color: black;
  margin-bottom: 4px;
  cursor: pointer;
}
.tagPostCard ul ion-auto-complete-item {
  height: 40px;
  width: 100%;
}
.tagPostCard ul li:last-child {
  border: none;
}
.tagPostCard ul li:hover {
  cursor: pointer;
  background: #f1f1f1;
}
.tagPostCard ul img {
  width: 17px;
  height: 17px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: -3px;
  margin-right: 5px;
}

.searchbar-left-aligned.sc-ion-searchbar-ios-h .searchbar-input.sc-ion-searchbar-ios {
  padding-inline-end: 0;
}

ion-icon {
  font-size: 30px;
  margin-top: 10px;
}

.hashtag {
  margin-top: 12px;
}

.tag-description {
  font-size: 12px;
  color: var(--ion-color-text-color);
}

.createPost {
  width: calc(100% - 48px);
  border: 1px solid var(--ion-color-tertiary-opacity);
  border-radius: 10px 10px 10px 10px;
}

.detail-view {
  /* margin-top: 14px !important;*/
}

.tagComment {
  height: auto;
  background: var(--planeed-color-white);
  padding-bottom: 1px;
  padding-top: 1px;
  padding-left: 14px;
  margin-bottom: -13px;
}
.tagComment ul {
  width: 92%;
  background: var(--planeed-color-white);
  list-style-type: none;
  padding: 0;
  left: 16px;
  z-index: 999;
  border: 1px var(--ion-color-medium-tint) solid;
  border-radius: 5px;
  max-height: 90px;
  overflow: auto;
}
.tagComment ul li {
  padding: 2px 15px;
  color: black;
}
.tagComment ul ion-auto-complete-item {
  height: 40px;
  width: 100%;
}
.tagComment ul li:last-child {
  border: none;
}
.tagComment ul li:hover {
  cursor: pointer;
  background: #f1f1f1;
}
.tagComment ul img {
  width: 17px;
  height: 17px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: -3px;
  margin-right: 5px;
}

.createAp {
  position: absolute;
  height: auto;
  background: var(--planeed-color-white);
  padding-bottom: 1px;
  padding-top: 0;
  margin-left: 15px;
  width: calc(100vw - 60px);
}
.createAp ul {
  width: 100%;
  background: var(--planeed-color-white);
  list-style-type: none;
  padding: 0;
  z-index: 999;
  border: 1px var(--ion-color-medium-tint) solid;
  border-radius: 5px;
  max-height: 90px;
  overflow: auto;
  margin-top: 0;
}
.createAp ul li {
  padding: 2px 15px;
  color: black;
}
.createAp ul ion-auto-complete-item {
  height: 40px;
  width: 100%;
}
.createAp ul li:last-child {
  border: none;
}
.createAp ul li:hover {
  cursor: pointer;
  background: #f1f1f1;
}
.createAp ul img {
  width: 17px;
  height: 17px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: -3px;
  margin-right: 5px;
}

.createPostOrSurvey {
  position: absolute;
  height: auto;
  background: var(--planeed-color-white);
  padding-bottom: 1px;
  padding-top: 0;
  margin-left: 15px;
  width: calc(100vw - 60px);
}
.createPostOrSurvey ul {
  width: 100%;
  background: var(--planeed-color-white);
  list-style-type: none;
  padding: 0;
  z-index: 999;
  border: 1px var(--ion-color-medium-tint) solid;
  border-radius: 5px;
  max-height: 90px;
  overflow: auto;
  margin-top: 0;
}
.createPostOrSurvey ul li {
  padding: 2px 15px;
  color: black;
}
.createPostOrSurvey ul ion-auto-complete-item {
  height: 40px;
  width: 100%;
}
.createPostOrSurvey ul li:last-child {
  border: none;
}
.createPostOrSurvey ul li:hover {
  cursor: pointer;
  background: #f1f1f1;
}
.createPostOrSurvey ul img {
  width: 17px;
  height: 17px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: -3px;
  margin-right: 5px;
}

.otherTag {
  height: auto;
  background: var(--planeed-color-white);
  padding-bottom: 1px;
  padding-top: 1px;
  padding-left: 14px;
  margin-bottom: -10px;
}
.otherTag ul {
  /*position: absolute;*/
  width: 89%;
  /*margin-top: -73px;*/
  /* margin-left: -3px;*/
  background: var(--planeed-color-white);
  list-style-type: none;
  padding: 0;
  left: 16px;
  z-index: 999;
  border: 1px var(--ion-color-medium-tint) solid;
  border-radius: 5px;
  max-height: 90px;
  overflow: auto;
}
.otherTag ul li {
  padding: 2px 15px;
  color: black;
}
.otherTag ul ion-auto-complete-item {
  height: 40px;
  width: 100%;
}
.otherTag ul li:last-child {
  border: none;
}
.otherTag ul li:hover {
  cursor: pointer;
  background: #f1f1f1;
}
.otherTag ul img {
  width: 17px;
  height: 17px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: -3px;
  margin-right: 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
